<button class="btn btn-tertiary me-6" type="button" (click)="copyToClipboard(id)">{{id.slice(-size)}}</button>
